import { render } from "./ownerAdd.vue?vue&type=template&id=e6400a12&scoped=true"
import script from "./ownerAdd.vue?vue&type=script&lang=js"
export * from "./ownerAdd.vue?vue&type=script&lang=js"

import "./ownerAdd.vue?vue&type=style&index=0&id=e6400a12&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6400a12"]])

export default __exports__